import React from "react";
import { Link } from "react-router-dom";
import { AppShell } from "../components/AppShell.js";

/** What a non-admin sees at an admin URL: the same answer the API gives, a 404. */
export const AdminNotFound: React.FC = () => (
  <AppShell>
    <div className="flex flex-col items-center gap-3 py-20 text-center">
      <h1 className="text-[20px] font-semibold text-ink-100">Page not found</h1>
      <Link to="/dashboard" className="btn btn-ghost btn-sm">
        Back to projects
      </Link>
    </div>
  </AppShell>
);

/** The small orange tag on the right of an admin page's breadcrumb. */
export const AdminTag: React.FC = () => (
  <span className="rounded-full bg-ember-400/10 px-2 py-[3px] text-[10.5px] font-semibold uppercase tracking-[0.06em] text-ember-600">
    Admin
  </span>
);

/** A filter chip: dark when on, outlined when off. */
export const Chip: React.FC<{ on: boolean; onClick: () => void; children: React.ReactNode }> = ({
  on,
  onClick,
  children,
}) => (
  <button
    type="button"
    aria-pressed={on}
    onClick={onClick}
    className={`whitespace-nowrap rounded-full border px-[11px] py-1.5 text-[12px] font-medium tabular-nums transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--edge-focus)] ${
      on
        ? "border-ink-100 bg-ink-100 text-bay-850"
        : "border-[var(--edge)] bg-bay-850 text-ink-300 hover:border-[var(--edge-strong)] hover:text-ink-100"
    }`}
  >
    {children}
  </button>
);
